import React from 'react';
import _ from 'lodash-es';
import { Link, Close } from '../library-components';
import './metadata-fields.scss';
import TextFieldWithLabel from '../../components/library-components/TextFieldWithLabel/TextFieldWithLabel';

function immutableSplice (arr, start, deleteCount, ...items) {
  return [...arr.slice(0, start), ...items, ...arr.slice(start + deleteCount)];
}

export default class MetadataFields extends React.Component {
  addNewMetadataField (e) {
    e.preventDefault();
    this.props.onChange(this.props.metadata_fields.concat(''));
  }

  updateMetadataField (index, value) {
    this.props.onChange(_.set(this.props.metadata_fields, index, value));
  }

  deleteMetadataField (e, index) {
    e.preventDefault();
    this.props.onChange(immutableSplice(this.props.metadata_fields, index, 1));
  }

  render () {
    return (
      <div className='metadata-fields'>
        {this.props.metadata_fields.map((metadataField, index) =>
          <div key={index} className='metadata-fields__input-group'>
            <TextFieldWithLabel label={` Metadata ${index + 1} `} value={metadataField} onChange={(e) => this.updateMetadataField(index, e.target.value)} placeholder='New Metadata Field' />
            <button className='metadata-fields__close-button' onClick={(e) => this.deleteMetadataField(e, index)} >
              <Close width='16px' height='16px' color='#132437' />
            </button>
          </div>
        )}
        <Link onClick={(e) => this.addNewMetadataField(e)} iconLeft='add-new' >Add New Field</Link>
      </div>);
  }
}
